// action enums
import { OfferTypesEnum } from './pricing-data.data';
import { PricingOffer } from './models/pricing-offer.model';

export enum ActionsEnum {
  FETCH_OFFER = 'FETCH_OFFER',
  SET_OFFER = 'SET_OFFER',
}

// action payload definitions
export interface IOfferTypePayload {
  offerType: OfferTypesEnum;
}

export interface IOfferPayload {
  offerType: OfferTypesEnum;
  offer: PricingOffer;
}

// action definitions
export interface FetchOffer {
  type: ActionsEnum.FETCH_OFFER;
  payload: IOfferTypePayload;
}

export interface SetOffer {
  type: ActionsEnum.SET_OFFER;
  payload: IOfferPayload;
}

// action creators
export const fetchOffer = (offerType: OfferTypesEnum): FetchOffer => ({
  type: ActionsEnum.FETCH_OFFER,
  payload: {
    offerType,
  },
});

export const setOffer = (offerType: OfferTypesEnum, offer: any): SetOffer => ({
  type: ActionsEnum.SET_OFFER,
  payload: {
    offerType,
    offer,
  },
});
